import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { Button } from 'carbon-components-react';
import { ArrowUp16, ArrowDown16, Arrows16 } from '@carbon/icons-react';
var ordering = {
  ASC: 'ASC',
  DESC: 'DESC',
  NONE: 'NONE'
};

var useSortableColumns = function useSortableColumns(hooks) {
  var sortableVisibleColumns = function sortableVisibleColumns(visibleColumns, _ref) {
    var instance = _ref.instance;
    var onSort = instance.onSort;

    var onSortClick = function onSortClick(column) {
      var key = column.id;
      var sortDesc = column.isSortedDesc;

      var _getNewSortOrder = getNewSortOrder(sortDesc),
          newSortDesc = _getNewSortOrder.newSortDesc,
          newOrder = _getNewSortOrder.newOrder;

      if (onSort) {
        onSort(key, newOrder);
      }

      instance.toggleSortBy(key, newSortDesc, false);
    };

    var sortableColumns = visibleColumns.map(function (column) {
      var icon = function icon(col) {
        if (col.isSorted) {
          switch (col.isSortedDesc) {
            case false:
              return ArrowUp16;

            case true:
              return ArrowDown16;

            default:
              return Arrows16;
          }
        }

        return Arrows16;
      };

      var Header = function Header(headerProp) {
        return column.disableSortBy === true ? column.Header : /*#__PURE__*/React.createElement(Button, {
          onClick: function onClick() {
            return onSortClick(headerProp.column);
          },
          kind: "ghost",
          renderIcon: icon(headerProp.column)
        }, column.Header);
      };

      return _objectSpread(_objectSpread({}, column), {}, {
        Header: Header
      });
    });
    return _toConsumableArray(sortableColumns);
  };

  var sortInstanceProps = function sortInstanceProps(instance) {
    var onSort = instance.onSort;
    Object.assign(instance, {
      manualSortBy: !!onSort,
      isTableSortable: true
    });
  };

  var getNewSortOrder = function getNewSortOrder(sortOrder) {
    var order = {
      newSortDesc: undefined,
      newOrder: ordering.NONE
    };

    if (sortOrder === false) {
      order.newOrder = ordering.DESC;
      order.newSortDesc = true;
    }

    if (sortOrder === undefined) {
      order.newOrder = ordering.ASC;
      order.newSortDesc = false;
    }

    return order;
  };

  hooks.visibleColumns.push(sortableVisibleColumns);
  hooks.useInstance.push(sortInstanceProps);
};

export default useSortableColumns;